const Services = () => {
	return (
		<>
			<h1 className="display-3 mb-4">Services</h1>
			Xeedo Technologies is best known for Manpower Staffing Company. It Provides services starting from Silicon to Final product Development.
		</>
	)
}
export default Services